import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as jspdf from 'jspdf';
import * as _ from 'lodash';
import * as moment from 'moment';
import { PDFDocument } from 'pdf-lib';
import { Observable, Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { WorkSheet } from 'xlsx';
import { CustomDesignPage } from '../../admin360/customization/models/custom-design-page.model';
import { EFormInstancesFilterParam } from '../../admin360/e-forms/e-form-instances/e-form-instances-filter-param';
import { EFormSubmissionsFilterParam } from '../../admin360/e-forms/e-form-submissions/e-form-submissions-filter-param';
import { ClassroomSummary } from '../../classroom360/classroom-summary/models/classroom-summary.model';
import { CSTCustomPage } from '../../shared-modules/customization-framework/models/cst-custom-page.model';
import { CSTField } from '../../shared-modules/customization-framework/models/custom-data-field.model';
import { CustomDataTemplateRef } from '../../shared-modules/customization-framework/models/custom-data-template-ref.model';
import { LoginService } from '../../shared-modules/login/login.service';
import { Service } from '../../student360/programs-and-services/service.model';
import { ExportService } from '../export.service';
import { Lookup } from '../lookup/lookup.model';
import { TylTranslation } from '../models/tyl-translation.model';
import { Staff } from '../staff-search/staff.model';
import { Student } from '../student/student.model';
import { StudentService } from '../student/student.service';
import { System } from '../System';
import { UserPermission } from '../user/user-permission.model';
import { User } from '../user/user.model';
import { UserService } from '../user/user.service';
import { School, SchoolStudentFamiliesInfo } from '../year/school.model';
import { YearService } from '../year/year.service';
import { EFormAttachment } from './e-form-attachment.model';
import { EFormCategory } from './e-form-category.model';
import { EFormChangeHistory } from './e-form-change-history.model';
import { EFormColumn } from './e-form-column.model';
import { EFormConfiguration } from './e-form-config.model';
import { EFormContact } from './e-form-contact.model';
import { EFormControl } from './e-form-control.model';
import { EFormDatabaseField } from './e-form-database-field.model';
import { EFormInstance } from './e-form-instance.model';
import { EFormMergeField } from './e-form-merge-field.model';
import { EFormPage } from './e-form-page.model';
import { EFormStatusHistory } from './e-form-status-history.model';
import { EformSubmissionCounts } from './e-form-submission-counts.model';
import { EFormSurveyAnswersFilterParam } from './e-form-survey-answer-details/e-form-survey-answers-filter/e-form-survey-answers-filter-param';
import { EFormsSurveyAnswerSummary } from './e-form-survey-answer-summary.model';
import { EFormSurveyAnswer } from './e-form-survey-answer.model';
import { EFormSurveyField } from './e-form-survey-field.model';
import { EFormsSurveySummary } from './e-form-survey-summary.model';
import { EFormTemplate } from './e-form-template.model';
import { EForm, EFormAvilableCount, EFormSelectedStudentInfo } from './e-form.model';
import { EFormDataObject } from './e-formDataObject.model';

@Injectable()
export class EFormService {

  renderedFormData: EFormDataObject;
  selectedFormData: EFormDataObject;
  selectedTemplate: EFormTemplate;
  selectedInstance: EFormInstance;
  selectedForm: EForm;
  selectedFormsToPDF: EForm[] = [];
  templates: EFormTemplate[] = [];
  userTemplates: EFormTemplate[] = [];
  categories: EFormCategory[] = [];
  databaseFields: EFormDatabaseField[] = [];
  mergeFields: EFormMergeField[] = [];
  selectedReviewInstanceId: number;
  selectedReviewInstanceName: string;
  selectedDesignPage: CustomDesignPage;
  selectedCustomPage: CSTCustomPage;
  eFormPermissions: UserPermission[] = [];
  instances: EFormInstance[] = [];
  viewType: string;
  initialS360eFormTab = '';
  allFormControls: EFormControl[] = [];
  allCustomFieldControls: EFormControl[] = [];
  // pdf: jspdf;
  pdf = PDFDocument.create();
  pdfDataURIs: string[] = [];
  changes: EFormChangeHistory[];
  manageEformsFilter: string;
  userType: User;
  selectedReviewInstance: EFormInstance;
  maxFileSizeKB = 2000;
  selectedReviewShowAllClasses: boolean;
  showInactive: boolean;
  homeLinkClickSelectedReviewShowAllClasses = false;
  homeLinkClickShowInactive = false;
  redirectFromClassic = false;
  redirectFromSubmision = false;
  eFormHeadLinePermission = false;
  V10 = false;
  eFormAttachment: EFormAttachment[] = [];
  eFormAttachmentForPDF: EFormAttachment[] = [];
  contentTemplates: CustomDataTemplateRef[];
  services: Service[] = [];
  showCriticalMessage = false;
  public surveyAnswersShowAllSchools = false;
  templateProcessType = '';
  categoryType = '';
  isComeFromSurvey = false;
  eFormSubmissionsFilterDateChange: boolean;
  districtLogo: SafeResourceUrl;
  siteLogo: SafeResourceUrl;
  alternateSiteLogo: SafeResourceUrl;
  alternateDistrictLogo: SafeResourceUrl;

  controlTypes = {
    text: 'text',
    divider: 'divider',
    verticalDivider: 'verticalDivider',
    image: 'image',
    buttons: 'buttons',
    checkbox: 'checkbox',
    checkboxWithTextbox: 'checkboxWithTextbox',
    dropdown: 'dropdown',
    note: 'note',
    radioButtons: 'radioButtons',
    textbox: 'textbox',
    date: 'date',
    attachment: 'attachment',
    linkToFile: 'linkToFile',
    customField: 'customField',
    component: 'component'
  };

  formStatus = {
    NotSubmitted: 'not submitted',
    Submitted: 'submitted',
    Rejected: 'rejected',
    Accepted: 'accepted',
    Complete: 'complete'
  };

  inputControlTypes: string[] = [
    this.controlTypes.buttons,
    this.controlTypes.checkbox,
    this.controlTypes.checkboxWithTextbox,
    this.controlTypes.dropdown,
    this.controlTypes.note,
    this.controlTypes.radioButtons,
    this.controlTypes.textbox,
    this.controlTypes.date,
    this.controlTypes.attachment
  ];

  public observablePageLoadComplete = new Subject<boolean>();
  observablePageLoadCompleteStream$ = this.observablePageLoadComplete.asObservable();

  public observableIsLastPage = new Subject<boolean>();
  observableIsLastPageStream$ = this.observableIsLastPage.asObservable();

  public observableIsFirstPage = new Subject<boolean>();
  observableIsFirstPageStream$ = this.observableIsFirstPage.asObservable();

  public observableControlValueChanged = new Subject<EFormControl>();
  observableControlValueChangedStream$ = this.observableControlValueChanged.asObservable();

  public observableShowConditionalObjects = new Subject<boolean>();
  observableShowConditionalObjectsStream$ = this.observableShowConditionalObjects.asObservable();

  public observableDatabaseFields = new Subject<EFormDatabaseField[]>();
  observableDatabaseFieldsStream$ = this.observableDatabaseFields.asObservable();

  public observableMergeFieldValuesRetrieved = new Subject<boolean>();
  observableMergeFieldValuesRetrievedStream$ = this.observableMergeFieldValuesRetrieved.asObservable();

  public observableMergeFieldsRetrieved = new Subject<boolean>();
  observableMergeFieldsRetrievedStream$ = this.observableMergeFieldsRetrieved.asObservable();

  public observablePipeTrigger = new Subject<boolean>();
  observablePipeTriggerStream$ = this.observablePipeTrigger.asObservable();

  public observableeFormHeadLinePermission = new Subject<EFormControl>();
  observableeFormHeadLinePermissionStream$ = this.observableeFormHeadLinePermission.asObservable();

  public observableeFormstrQueryXML = new Subject<string>();
  observableeFormstrQueryXML$ = this.observableeFormstrQueryXML.asObservable();

  private _surveyAnswersFilterParam: EFormSurveyAnswersFilterParam;
  public observablesurveyAnswersFilterParam = new Subject<EFormSurveyAnswersFilterParam>();
  observablesurveyAnswersFilterParamStream$ = this.observablesurveyAnswersFilterParam.asObservable();

  public observableReadOnlyStatusChanged = new Subject<EFormControl>();
  observableReadOnlyStatusChangedStream$ = this.observableReadOnlyStatusChanged.asObservable();


  _filterParam: EFormInstancesFilterParam;
  filterParamManageSurveys: EFormInstancesFilterParam = new EFormInstancesFilterParam();
  filterParamManageEForms: EFormInstancesFilterParam = new EFormInstancesFilterParam();
  filterChange = new EventEmitter<any>();

  _eFormSubmissionsFilterParam: EFormSubmissionsFilterParam;
  eFormSubmissionsFilterChange = new EventEmitter<any>();

  set filterParam(filterParam: EFormInstancesFilterParam) {
    this._filterParam = filterParam;
    this.filterChange.emit();
  }

  get filterParam() {
    return this._filterParam;
  }

  isFiltered(): boolean {
    return !!this.filterParam.availableTo ||
      !!this.filterParam.selectedSites ||
      !!this.filterParam.selectedClasses ||
      !!this.filterParam.selectedStudents ||
      !!this.filterParam.deadlineFrom ||
      !!this.filterParam.deadlineTo ||
      !!this.filterParam.showFromFrom ||
      !!this.filterParam.showFromTo ||
      !!this.filterParam.showToFrom ||
      !!this.filterParam.showToTo ||
      !!this.filterParam.category ||
      !!this.filterParam.template ||
      !!this.filterParam.createdFrom ||
      !!this.filterParam.createdTo ||
      !!this.filterParam.createdBy ||
      !!this.filterParam.lastUpdatedFrom ||
      !!this.filterParam.lastUpdatedTo ||
      !!this.filterParam.lastUpdatedBy;
  }

  set eFormSubmissionsFilterParam(eFormSubmissionsFilterParam: EFormSubmissionsFilterParam) {
    this._eFormSubmissionsFilterParam = eFormSubmissionsFilterParam;
    this.eFormSubmissionsFilterChange.emit();
  }

  get eFormSubmissionsFilterParam() {
    return this._eFormSubmissionsFilterParam;
  }

  isEFormSubmissionsFiltered(): boolean {
    return !this.eFormSubmissionsFilterParam.notSubmitted ||
      !this.eFormSubmissionsFilterParam.submitted ||
      !this.eFormSubmissionsFilterParam.rejected ||
      !this.eFormSubmissionsFilterParam.accepted ||
      !this.eFormSubmissionsFilterParam.complete ||
      !!this.eFormSubmissionsFilterParam.submittedFrom ||
      !!this.eFormSubmissionsFilterParam.submittedTo ||
      this.eFormSubmissionsFilterParam.manualSubmission != '0';
  }

  public get surveyAnswersFilterParam(): EFormSurveyAnswersFilterParam {
    return this._surveyAnswersFilterParam;
  }
  public set surveyAnswersFilterParam(value: EFormSurveyAnswersFilterParam) {
    this._surveyAnswersFilterParam = value;
    this.observablesurveyAnswersFilterParam.next(value);
  }

  isSurveyAnswersFiltered(): boolean {
    return this.surveyAnswersFilterParam && ((this.surveyAnswersFilterParam.dateFilterType == 'byDate' && this.surveyAnswersFilterParam.specificDate != null)
      || (this.surveyAnswersFilterParam.dateFilterType == 'fromDate' && this.surveyAnswersFilterParam.fromDate != null)
      || (this.surveyAnswersFilterParam.dateFilterType == 'betweenDates' && (this.surveyAnswersFilterParam.rangeStartDate != null || this.surveyAnswersFilterParam.rangeEndDate != null)));
  }

  constructor(
    private http: HttpClient,
    private yearService: YearService,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private loginService: LoginService,
    private exportService: ExportService,
    private studentService: StudentService
  ) {
    this._filterParam = new EFormInstancesFilterParam();
    this._eFormSubmissionsFilterParam = new EFormSubmissionsFilterParam();
    this.V10 = this.loginService.LoginSettings.V10;
  }

  getAllFormTextToTranslate(formData: EFormDataObject): TylTranslation[] {
    const controls: EFormControl[] = this.getAllFormControls(formData);
    const translations: TylTranslation[] = [];

    controls.forEach(control => {
      if (control.ControlType != 'component') {
        let controlTranslations: TylTranslation[] = [];

        controlTranslations = this.getControlLabels(control);

        if (controlTranslations.length > 0) {
          controlTranslations.forEach(controlTranslation => {
            if (translations.findIndex(translation => translation.English == controlTranslation.English) == -1) {
              translations.push(controlTranslation);
            }
          });
        }
      }
    });

    return translations;
  }

  getControlLabels(control: EFormControl): TylTranslation[] {
    const textToTranslate: TylTranslation[] = [];

    if (control.Label) {
      textToTranslate.push(new TylTranslation(control.Label));
    }
    if (control.ControlType == 'text') {
      if (control.Value) {
        textToTranslate.push(new TylTranslation(control.Value, true));
      }
    }
    if (control.ControlType == 'buttons') {
      if (control.DropdownOptions) {
        control.DropdownOptions.forEach(chip => {
          if (chip.CodeDescription) {
            textToTranslate.push(new TylTranslation(chip.CodeDescription));
          }
        });
      }
    }
    if (control.ControlType == 'dropdown' || control.ControlType == 'radioButtons') {
      if (control.DropdownOptions) {
        control.DropdownOptions.forEach(option => {
          if (option.CodeDescription) {
            textToTranslate.push(new TylTranslation(option.CodeDescription));
          }
        });
      }
    }

    return textToTranslate;
  }

  getAllFormControls(formData: EFormDataObject): EFormControl[] {
    let controls: EFormControl[] = [];
    if (formData && formData.Tabs != null && formData.Tabs) {
      formData.Tabs.forEach(tab => {
        tab.Pages.forEach(page => {
          const pageControls = this.getAllControlsByPage(page);
          if (pageControls.length > 0) {
            controls = controls.concat(pageControls);
          }
        });
      });
    }

    return controls;
  }

  getAllControlsByPage(page: EFormPage): EFormControl[] {
    let controls: EFormControl[] = [];
    page.Columns.forEach(column => {
      const colControls = this.getAllControlsByColumn(column);
      if (colControls.length > 0) {
        controls = controls.concat(colControls);
      }
    });
    return controls;
  }

  getAllControlsByColumn(column: EFormColumn): EFormControl[] {
    let controls: EFormControl[] = [];
    if (column.Controls.length > 0) {
      controls = controls.concat(column.Controls);
    }
    column.Rows.forEach(row => {
      if (row.Controls.length > 0) {
        controls = controls.concat(row.Controls);
      }
      row.Columns.forEach(col => {
        const colControls = this.getAllControlsByColumn(col);
        if (colControls.length > 0) {
          controls = controls.concat(colControls);
        }
      });
    });
    return controls;
  }

  isConditionMet(condition: string | boolean, parentControl: EFormControl): boolean {
    let conditionMet = false;
    if (parentControl.ControlType == this.controlTypes.textbox || parentControl.ControlType == this.controlTypes.note) {
      if (condition == 'blank') {
        conditionMet = !parentControl.Value;
      }
      else {
        conditionMet = !!parentControl.Value;
      }
    }
    else if (parentControl.ControlType == this.controlTypes.checkbox || parentControl.ControlType == this.controlTypes.checkboxWithTextbox) {
      if (condition == 'false') {
        conditionMet = !parentControl.Value;
      }
      else {
        conditionMet = !!parentControl.Value;
      }
    }
    else {
      if (typeof (parentControl.Value) === 'string' && parentControl.Value) {
        conditionMet = condition.toString().trim() == parentControl.Value.trim();
      }
      else {
        conditionMet = condition == parentControl.Value;
      }
    }
    return conditionMet;
  }

  formatControlName(control: EFormControl): string {
    const id = control.Id ? control.Id.toString() : '';
    let controlType = '';
    let name = '';
    if (control.ControlType == this.controlTypes.text) {
      name = control.Value ? control.Value : '';
    }
    else {
      name = control.Label ? control.Label : '';
    }
    if (name.length > 20) {
      name = name.substr(0, 20) + '...';
    }
    controlType = this.formatControlType(control.ControlType);

    // return 'Control ' + id + ' - ' + controlType + ' (' + name + ')';
    return controlType + ' - ' + name + ' (' + id + ')';
  }

  formatControlNameForErrors(control: EFormControl): string {
    const id = control.Id ? control.Id.toString() : '';
    let controlType = '';
    let name = '';
    if (control.ControlType == this.controlTypes.text) {
      name = control.Value ? control.Value : '';
    }
    else {
      name = control.Label ? control.Label : '';
    }
    if (name.length > 20) {
      name = name.substr(0, 20) + '...';
    }
    controlType = this.formatControlType(control.ControlType);

    // return 'Control ' + id + ' - ' + controlType + ' (' + name + ')';
    return controlType + ' (' + name + ')';
  }

  formatControlType(type: string): string {
    let controlType = '';
    switch (type) {
      case this.controlTypes.attachment: {
        controlType = 'Attachment Request';
        break;
      }
      case this.controlTypes.buttons: {
        controlType = 'Buttons';
        break;
      }
      case this.controlTypes.checkbox: {
        controlType = 'Checkbox';
        break;
      }
      case this.controlTypes.date: {
        controlType = 'Date';
        break;
      }
      case this.controlTypes.divider: {
        controlType = 'Divider';
        break;
      }
      case this.controlTypes.verticalDivider: {
        controlType = 'Vertical Divider';
        break;
      }
      case this.controlTypes.dropdown: {
        controlType = 'Dropdown';
        break;
      }
      case this.controlTypes.image: {
        controlType = 'Image';
        break;
      }
      case this.controlTypes.linkToFile: {
        controlType = 'Link to File';
        break;
      }
      case this.controlTypes.note: {
        controlType = 'Multi-line Textbox';
        break;
      }
      case this.controlTypes.radioButtons: {
        controlType = 'Radio Buttons';
        break;
      }
      case this.controlTypes.text: {
        controlType = 'Text';
        break;
      }
      case this.controlTypes.textbox: {
        controlType = 'Textbox';
        break;
      }
    }
    return controlType;
  }

  extractMergeTags(eFormData: EFormDataObject, config: EFormConfiguration): string[] {
    let allTags: string[] = [];
    if (config.ShowHeader) {
      allTags = ['<<Family parents combined mailing name>>', '<<Family Address - Street Number, Name, Apt>>', '<<Family Address - City, State, Zip>>', '<<Student name - full (first last)>>'];
      if (config.ShowHeaderSchoolName) {
        allTags.push('<<Behavior School Name>>');
      }
      if (config.ShowHeaderSchoolAddress) {
        allTags.push('<<Behavior School Address>>');
      }
    }

    let formattedTags: string[] = [];
    const controls = this.getAllFormControls(eFormData);
    const normalRegEx = new RegExp('<<(.*?)>>', 'g');
    const sanitizedRegEx = new RegExp('&lt;&lt;(.*?)&gt;&gt;', 'g');
    controls.forEach(control => {
      allTags = allTags.concat(control.Label.match(normalRegEx));
      allTags = allTags.concat(control.Label.match(sanitizedRegEx));
      if (control.ControlType == this.controlTypes.text) {
        if (control.Value) {
          allTags = allTags.concat(control.Value.match(normalRegEx));
          allTags = allTags.concat(control.Value.match(sanitizedRegEx));
        }
      }
      control.DropdownOptions.forEach(opt => {
        allTags = allTags.concat(opt.CodeDescription.match(normalRegEx));
        allTags = allTags.concat(opt.CodeDescription.match(sanitizedRegEx));
      });
    });

    const leftAngleRegEx = new RegExp('&lt;&lt;', 'g');
    const rightAngleRegEx = new RegExp('&gt;&gt;', 'g');
    formattedTags = _.map(_.uniq(allTags).filter(o => !!o), o => o.replace(leftAngleRegEx, '<<').replace(rightAngleRegEx, '>>'));
    return formattedTags;
  }

  clearMergeFieldValues() {
    this.mergeFields.forEach(f => {
      f.Value = '';
    });
  }

  mergeFieldValuesRetrieved() {
    this.observableMergeFieldValuesRetrieved.next(true);
  }

  mergeFieldPipeTrigger() {
    this.observablePipeTrigger.next(true);
  }

  controlValueChanged(control: EFormControl) {
    this.observableControlValueChanged.next(control);
  }

  showConditionalObjectsChanged(showObjects: boolean) {
    this.observableShowConditionalObjects.next(showObjects);
  }

  getCategories(): Observable<EFormCategory[]> {
    return this.http.get<EFormCategory[]>(System.apiURL.Student + 'GetEformCategories');
  }

  saveCategory(category: EFormCategory): Observable<EFormCategory[]> {
    return this.http.post<EFormCategory[]>(System.apiURL.Student + 'SaveEformCategory', category);
  }

  getAllTemplates(yearId: number): Observable<EFormTemplate[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.get<EFormTemplate[]>(System.apiURL.Student + 'GetAllEFormTemplates' + queryString);
  }

  getEFormTemplate(templateId: number): Observable<EFormTemplate> {
    const queryString = '?templateId=' + templateId;

    return this.http.get<EFormTemplate>(System.apiURL.Student + 'GetEformTemplate' + queryString);
  }

  saveTemplate(template: EFormTemplate): Observable<EFormTemplate> {
    return this.http.post<EFormTemplate>(System.apiURL.Student + 'SaveEformTemplate', template);
  }

  getMergeFields(): Observable<EFormMergeField[]> {
    return this.http.get<EFormMergeField[]>(System.apiURL.Student + 'GetMergeFields');
  }

  getEFormDatabaseFields(): Observable<EFormDatabaseField[]> {
    return this.http.get<EFormDatabaseField[]>(System.apiURL.Student + 'GetEFormDatabaseFields');
  }

  getEFormDatabaseFieldOptions(fieldId: number, yearId: number): Observable<Lookup[]> {
    const queryString = '?fieldId=' + fieldId +
      '&yearId=' + yearId;
    return this.http.get<Lookup[]>(System.apiURL.Student + 'GetEFormDatabaseFieldOptions' + queryString);
  }

  getEFormAttachment(attachmentId: number): Observable<EFormAttachment> {
    const queryString = '?attachmentId=' + attachmentId;
    return this.http.get<EFormAttachment>(System.apiURL.Student + 'GetEFormAttachment' + queryString);
  }

  getEFormAttachments(attachmentIds: number[]): Observable<EFormAttachment[]> {
    return this.http.post<EFormAttachment[]>(System.apiURL.Student + 'GetEFormAttachments', attachmentIds);
  }

  getManualSubmissionAttachment(formId: number): Observable<EFormAttachment> {
    const queryString = '?formId=' + formId;
    return this.http.get<EFormAttachment>(System.apiURL.Student + 'GetManualSubmissionAttachment' + queryString);
  }

  deleteEFormAttachments(attachmentIds: number[]): Observable<void> {
    return this.http.post<void>(System.apiURL.Student + 'DeleteEFormAttachments', attachmentIds);
  }

  saveEFormAttachments(attachments: EFormAttachment[]): Observable<EFormAttachment[]> {
    return this.http.post<EFormAttachment[]>(System.apiURL.Student + 'SaveEFormAttachments', attachments);
  }

  saveManualSubmissionAttachment(formId: number, attachment: EFormAttachment): Observable<EFormAttachment> {
    let queryString = '';
    queryString += '?formId=' + formId;

    return this.http.post<EFormAttachment>(System.apiURL.Student + 'SaveManualSubmissionAttachment' + queryString, attachment);
  }

  getInstancesForProcessing(yearId: number, schoolId: number, showCountsForAllSchools: boolean, eFormSurvey: boolean, includeInactive: boolean): Observable<EFormInstance[]> {
    let queryString = '';
    queryString += '?yearId=' + yearId;
    queryString += '&schoolId=' + schoolId;
    queryString += '&showCountsForAllSchools=' + showCountsForAllSchools;
    queryString += '&eFormSurvey=' + eFormSurvey;
    queryString += '&includeInactive=' + includeInactive;

    return this.http.get<EFormInstance[]>(System.apiURL.Student + 'GetInstancesForProcessing' + queryString);
  }

  // getEForms(instanceId: number, yearId: number, school_domain: number, showCountsForAllSchools: boolean, formId: number = 0): Observable<EForm[]> {
  //   let queryString = '';
  //   queryString += '?instanceId=' + instanceId;
  //   queryString += '&yearId=' + yearId;
  //   queryString += '&school_domain=' + school_domain;
  //   queryString += '&showCountsForAllSchools=' + showCountsForAllSchools;
  //   queryString += '&formId=' + formId;

  //   return this.http.get<EForm[]>(System.apiURL.Student + 'GetEforms' + queryString);
  // }

  getEForms(instanceId: number, yearId: number, school_domain: number, showCountsForAllSchools: boolean, formId: number = 0, exportData: boolean = false, instanceIds: number[] = [], isOnlyForExportData: boolean = false, blnNotSubmitted: boolean = false, blnSubmitted: boolean = false, blnRejected: boolean = false, blnAccepted: boolean = false, blnComplited: boolean = false): Observable<EForm[]> {
    let fromDate;
    let toDate;
    const notSubmittedFilter = this.eFormSubmissionsFilterParam.notSubmitted;
    if (this.eFormSubmissionsFilterParam.submittedFrom) {
      fromDate = moment(this.eFormSubmissionsFilterParam.submittedFrom, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY');
    }
    else {
      fromDate = moment().toDate().toLocaleDateString();
    }
    if (this.eFormSubmissionsFilterParam.submittedTo) {
      toDate = moment(this.eFormSubmissionsFilterParam.submittedTo, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY');
    }
    else {
      toDate = moment().toDate().toLocaleDateString();
    }
    let queryString = '';
    queryString += '?instanceId=' + instanceId;
    queryString += '&yearId=' + yearId;
    queryString += '&school_domain=' + school_domain;
    queryString += '&showCountsForAllSchools=' + showCountsForAllSchools;
    queryString += '&formId=' + formId;
    queryString += '&exportData=' + exportData;
    queryString += '&isOnlyForExportData=' + isOnlyForExportData;
    queryString += '&blnNotSubmitted=' + blnNotSubmitted;
    queryString += '&blnSubmitted=' + blnSubmitted;
    queryString += '&blnRejected=' + blnRejected;
    queryString += '&blnAccepted=' + blnAccepted;
    queryString += '&blnComplited=' + blnComplited;
    queryString += '&datFromDate=' + fromDate;
    queryString += '&datToDate=' + toDate;
    queryString += '&notSubmittedFilterApplied=' + notSubmittedFilter;


    return this.http.post<EForm[]>(System.apiURL.Student + 'GetEforms' + queryString, instanceIds);
  }

  populateFormData(form: EForm): Observable<EForm> {
    return this.http.post<EForm>(System.apiURL.Student + 'PopulateFormData', form);
  }

  getFormDataOnlyByIDs(formIds: number[]): Observable<EForm[]> {
    return this.http.post<EForm[]>(System.apiURL.Admin + 'GetFormDataOnlyByIDs', formIds);
  }

  getFormDataByInstanceId(yearId: number, formId: number = 0, instanceIds: number[] = []): Observable<EForm[]> {
    let queryString = '';
    queryString += '?yearId=' + yearId;
    queryString += '&formId=' + formId;
    return this.http.post<EForm[]>(System.apiURL.Student + 'GetFormDataByInstanceId' + queryString, instanceIds);
  }

  getStudentParentEforms(): Observable<EForm[]> {
    let studentId = 0;
    let schoolDomain = -1;
    let yearId: number = this.yearService.student360Year.Id;
    // here this.userService.currentUser.UserType == 3 means Student login
    if (!this.loginService.LoginSettings.V10 && this.userService.currentUser.UserType == 3) {
      studentId = this.userService.currentUser.StudentId;
    }
    if (this.userService.currentUser.UserType == 1) {
      studentId = this.studentService.selectedStudent.Id;
      yearId = this.yearService.defaultYear.Id;
    }
    if (!this.loginService.LoginSettings.V10) {
      schoolDomain = this.yearService.student360Year.SchoolID;
    }
    let queryString = '';
    queryString += '?yearId=' + this.yearService.student360Year.Id;
    queryString += '&school_domain=' + schoolDomain;
    queryString += '&studentId=' + studentId;

    return this.http.get<EForm[]>(System.apiURL.Student + 'GetStudentParentEforms' + queryString);
  }

  getStaffUserEformsByLoginId(): Observable<EForm[]> {
    let queryString = '';
    queryString += '?yearId=' + this.yearService.defaultYear.Id;

    return this.http.get<EForm[]>(System.apiURL.Admin + 'GetStaffUserEformsByLoginId' + queryString);
  }

  CheckEformsStatus(formId: number, instanceId: number, studentId: number, parentMemId: number, primaryParentMemId: number): Observable<EForm> {
    let queryString = '';
    queryString += '?formId=' + (formId ? formId : 0);
    queryString += '&instanceId=' + instanceId;
    queryString += '&studentId=' + (studentId ? studentId : 0);
    queryString += '&parentMemId=' + (parentMemId ? parentMemId : 0);
    queryString += '&primaryParentMemId=' + (primaryParentMemId ? primaryParentMemId : 0);

    return this.http.get<EForm>(System.apiURL.Student + 'CheckEformsStatus' + queryString);
  }

  checkForAvailableEForms(required: boolean, filterMarkedAsSeen: boolean = false): Observable<EFormAvilableCount> {
    let studentId = 0;
    let schoolDomain = -1;
    // here this.userService.currentUser.UserType == 3 means Student login
    if (this.userService.currentUser.UserType == 3) {
      studentId = this.userService.currentUser.StudentId;
      if (studentId == 0 && this.loginService.LoginSettings.V10) {
        studentId = -1;
      }
    }
    if (!this.loginService.LoginSettings.V10) {
      schoolDomain = this.yearService.student360Year.SchoolID;
    }
    let queryString = '';
    queryString += '?yearId=' + this.yearService.student360Year.Id;
    queryString += '&school_domain=' + schoolDomain;
    queryString += '&required=' + required;
    queryString += '&filterMarkedAsSeen=' + filterMarkedAsSeen;
    queryString += '&studentId=' + studentId;

    return this.http.get<EFormAvilableCount>(System.apiURL.Student + 'CheckForAvailableEForms' + queryString);
  }

  checkForAvailableStaffEForms(): Observable<EFormAvilableCount> {
    let queryString = '';
    queryString += '?yearId=' + this.yearService.defaultYear.Id;

    return this.http.get<EFormAvilableCount>(System.apiURL.Admin + 'CheckForAvailableStaffEForms' + queryString);
  }

  saveEForm(eForm: EForm, comment: string = null, updatePDF: boolean = false, siteYearId: number = -1): Observable<EForm> {
    let queryString = '?comment=' + comment;
    queryString += '&updatePDF=' + updatePDF;
    queryString += '&templateProcessType=' + this.templateProcessType;
    queryString += '&categoryType=' + this.categoryType;
    queryString += '&siteYearId=' + siteYearId;
    return this.http.post<EForm>(System.apiURL.Student + 'SaveEform' + queryString, eForm);
  }

  updateEFormPDFData(eForm: EForm, comment: string = null): Observable<EForm> {
    const queryString = '?comment=' + comment;
    return this.http.post<EForm>(System.apiURL.Student + 'UpdateEFormPDFData' + queryString, eForm);
  }

  GetEformStatusHistory(formId: number): Observable<EFormStatusHistory[]> {
    let queryString = '';
    queryString += '?formId=' + formId;

    return this.http.get<EFormStatusHistory[]>(System.apiURL.Student + 'GetEformStatusHistory' + queryString);
  }

  SaveEformStatusHistory(eFormStatusHistory: EFormStatusHistory): Observable<EFormStatusHistory> {
    return this.http.post<EFormStatusHistory>(System.apiURL.Student + 'SaveEformStatusHistory', eFormStatusHistory);
  }

  getEformContact(formId: number): Observable<EFormContact> {
    let queryString = '';
    queryString += '?formId=' + formId;

    return this.http.get<EFormContact>(System.apiURL.Student + 'GetEformContact' + queryString);
  }

  getSchoolsByDomains(schoolDomains: number[]): Observable<School[]> {
    return this.http.post<School[]>(System.apiURL.Student + 'GetSchoolsByDomains', schoolDomains);
  }

  getClassesBySectionId(schoolId: number, yearId: number, sectionIds: number[]): Observable<ClassroomSummary[]> {
    const queryString = '?schoolId=' + schoolId +
      '&yearId=' + yearId;
    return this.http.post<ClassroomSummary[]>(System.apiURL.Student + 'GetClassesBySectionId' + queryString, sectionIds);
  }

  getClassesByTgsId(schoolId: number, yearId: number, tgsIds: number[], includeStudentIds: boolean = false): Observable<ClassroomSummary[]> {
    const queryString = '?schoolId=' + schoolId +
      '&yearId=' + yearId +
      '&includeStudentIds=' + includeStudentIds;
    return this.http.post<ClassroomSummary[]>(System.apiURL.Student + 'GetClassesByTGSId' + queryString, tgsIds);
  }

  getUserEformTemplates(isFormDataRequired: boolean = true, templateId: number = 0): Observable<EFormTemplate[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&isFormDataRequired=' + isFormDataRequired +
      '&templateId=' + templateId;
    return this.http.get<EFormTemplate[]>(System.apiURL.Student + 'GetUserEformTemplates' + queryString);
  }

  getEformPermissions(yearId: number): Observable<UserPermission[]> {
    const queryString = '?yearId=' + yearId;
    return this.http.get<UserPermission[]>(System.apiURL.Student + 'GetEformPermissions' + queryString);
  }

  saveInstance(instance: EFormInstance): Observable<EFormInstance> {
    return this.http.post<EFormInstance>(System.apiURL.Student + 'SaveEformInstance', instance);
  }

  checkInstanceName(instance: EFormInstance): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Student + 'CheckInstanceName', instance);
  }

  getMergeFieldValues(formData: EFormDataObject, schoolId: number, yearId: number, studentId: number, parentId: number, incidentId: number, involvementType: string, config: EFormConfiguration, nonResidentParents: boolean = false) {
    if (!this.mergeFields || this.mergeFields.length == 0) {
      this.getMergeFields().subscribe(mergeFields => {
        this.mergeFields = mergeFields;
        this.observableMergeFieldsRetrieved.next(true);
        if (studentId || parentId || incidentId) {
          this.retrieveMergeFieldValues(formData, schoolId, yearId, studentId, parentId, incidentId, involvementType, config, nonResidentParents);
        }
        else {
          this.mergeFieldValuesRetrieved();
        }
      });
    }
    else {
      if (studentId || parentId || incidentId) {
        this.retrieveMergeFieldValues(formData, schoolId, yearId, studentId, parentId, incidentId, involvementType, config, nonResidentParents);
      }
    }
  }

  retrieveMergeFieldValues(formData: EFormDataObject, schoolId: number, yearId: number, studentId: number, parentId: number, incidentId: number, involvementType: string, config: EFormConfiguration, nonResidentParents: boolean) {
    const queryString = '?studentId=' + studentId +
      '&parentId=' + parentId +
      '&schoolId=' + schoolId +
      '&yearId=' + yearId +
      '&incidentId=' + incidentId +
      '&involvementType=' + involvementType +
      '&nonResidentParents=' + nonResidentParents;

    const mergeTags = this.extractMergeTags(formData, config);
    for (let i = 0; i < mergeTags.length; i++) {
      mergeTags[i] = mergeTags[i].replace('<<student', '<<Student');
      mergeTags[i] = mergeTags[i].toLocaleLowerCase();
    }
    const selectedTags = this.mergeFields.filter(o => mergeTags.includes(o.FieldName.toLocaleLowerCase()));
    this.http.post<EFormMergeField[]>(System.apiURL.Student + 'GetMergeFieldValue' + queryString, selectedTags).subscribe(results => {
      this.mergeFields.forEach(f => {
        const translatedField = results.find(o => o.ID == f.ID);
        if (translatedField) {
          f.Value = translatedField.Value;
        }
        else {
          f.Value = '';
        }
      });
      this.mergeFieldValuesRetrieved();
    });
  }

  getEFormStudentsByInstanceId(yearId: number, schoolId: number, instanceId: number): Observable<Student[]> {
    let studentId = 0;
    if (this.userService.currentUser.UserType == 3) {
      studentId = this.userService.currentUser.StudentId;
    }
    const queryString = '?yearId=' + yearId +
      '&schoolId=' + schoolId +
      '&instanceId=' + instanceId +
      '&studentId=' + studentId;

    return this.http.get<Student[]>(System.apiURL.Student + 'GetEFormStudentsByInstanceId' + queryString);
  }

  getSchoolIdsByClassIds(classIds: number[]): Observable<number[]> {
    return this.http.post<number[]>(System.apiURL.Student + 'GetSchoolIdsByCourseSectionIds', classIds);
  }

  getSchoolIdsByStudentIds(yearId: number, studentIds: number[]): Observable<number[]> {
    const queryString = '?yearId=' + yearId;

    return this.http.post<number[]>(System.apiURL.Student + 'GetSchoolIdsByStudentIds' + queryString, studentIds);
  }

  canCreateUserProcessEform(yearId: number, instance: EFormInstance): Observable<boolean> {
    const queryString = '?yearId=' + yearId;

    return this.http.post<boolean>(System.apiURL.Student + 'CanCreateUserProcessEform' + queryString, instance);
  }

  getEformCreateByStaffId(instanceId: number): Observable<number> {
    const queryString = '?instanceId=' + instanceId;

    return this.http.get<number>(System.apiURL.Student + 'GetEformCreateByStaffId' + queryString);
  }

  getEFormInstance(instanceId: number): Observable<EFormInstance> {
    const queryString = '?instanceId=' + instanceId;

    return this.http.get<EFormInstance>(System.apiURL.Student + 'GetEFormInstance' + queryString);
  }

  getEformCategoryByInstanceId(instanceId: number): Observable<EFormCategory> {
    const queryString = '?instanceId=' + instanceId;

    return this.http.get<EFormCategory>(System.apiURL.Student + 'GetEformCategoryByInstanceId' + queryString);
  }

  updateLinkedDBFields(formId: number, dbFields: EFormDatabaseField[]): Observable<boolean> {
    const queryString = '?formId=' + formId;
    return this.http.post<boolean>(System.apiURL.Student + 'UpdateEFormLinkedDBFields' + queryString, dbFields);
  }

  getLinkedDBFields(form: EFormDataObject): EFormDatabaseField[] {
    const newValues: EFormDatabaseField[] = [];
    const controls = this.getAllFormControls(form);
    controls.forEach(control => {
      if (control.LinkedDBField > 0 && control.Visible && (!this.loginService.LoginSettings.EnableCustomizationFramework || !this.loginService.LoginSettings.C360CustomFieldsImported || !control.LinkedCSTFieldName)) {
        const dbField = new EFormDatabaseField();
        dbField.ID = control.LinkedDBField;
        if (control.Value) {
          dbField.Value = control.Value.toString();
        }
        newValues.push(dbField);
      }
    });
    return newValues;
  }

  getLinkedDBFieldValues(fieldIds: number[], studentId: number): Observable<EFormDatabaseField[]> {
    const queryString = '?yearId=' + this.yearService.student360Year.Id +
      '&studentId=' + studentId;
    return this.http.post<EFormDatabaseField[]>(System.apiURL.Student + 'GetLinkedDBFieldValues' + queryString, fieldIds);
  }

  getControlIdFromMergeTag(mergeTag: string): number {
    let controlId = '';
    let endIndex = mergeTag.lastIndexOf(')>>');
    if (endIndex <= 0) {
      endIndex = mergeTag.lastIndexOf(')&gt;&gt;');
    }
    let startIndex = mergeTag.lastIndexOf('(');
    if (startIndex >= 0 && endIndex > startIndex) {
      startIndex += 1;
      const idLength = endIndex - startIndex;
      controlId = mergeTag.substr(startIndex, idLength);
    }
    return Number(controlId);
  }

  transformDatabaseMergeTag(text: string): string {
    if (this.mergeFields && this.mergeFields.length) {
      text = this.translateMergeField(text);
      // ################# logic for ignore case convert merge field in lower case
      for (let i = 0; i < text.length; i++) {
        const indxOfStart = text.indexOf('<<');
        const indxOfEnd = text.indexOf('>>');
        if (indxOfStart < 0 || indxOfEnd < 0) {
          break;
        }
        if (i >= indxOfEnd) {
          const subStr = text.substring(i, text.length);
          const indxOfStart_II = subStr.indexOf('<<');
          const indxOfEnd_II = subStr.indexOf('>>');
          const mergeFieldData_II = subStr.substring(indxOfStart_II, indxOfEnd_II + 2);
          if (indxOfStart_II != -1 && indxOfEnd_II != -1) {
            text = text.replace(mergeFieldData_II, mergeFieldData_II.toLowerCase());
            i = i + indxOfEnd_II + 1;
          }
        }

        if (i <= indxOfStart) {
          const mergeFieldData = text.substring(indxOfStart, indxOfEnd + 2);
          text = text.replace(mergeFieldData, mergeFieldData.toLowerCase());
          i = indxOfEnd + 1;
        }
      }
      // ################## logic for ignore case convert merge field in lower case for text area
      for (let i = 0; i < text.length; i++) {
        const indxOfStart = text.indexOf('&lt;');
        const indxOfEnd = text.indexOf('&gt');
        if (indxOfStart < 0 || indxOfEnd < 0) {
          break;
        }
        if (i >= indxOfEnd) {
          const subStr = text.substring(i, text.length);
          const indxOfStart_II = subStr.indexOf('&lt;');
          const indxOfEnd_II = subStr.indexOf('&gt');
          const mergeFieldData_II = subStr.substring(indxOfStart_II, indxOfEnd_II + 2);
          if (indxOfStart_II != -1 && indxOfEnd_II != -1) {
            text = text.replace(mergeFieldData_II, mergeFieldData_II.toLowerCase());
            i = i + indxOfEnd_II + 1;
          }
        }

        if (i <= indxOfStart) {
          const mergeFieldData = text.substring(indxOfStart, indxOfEnd + 2);
          text = text.replace(mergeFieldData, mergeFieldData.toLowerCase());
          i = indxOfEnd + 1;
        }
      }
      // #################
      text = this.translateMergeField(text);
    }
    return text;
  }

  translateMergeField(text) {
    this.mergeFields.forEach(mf => {
      // mf.FieldName = mf.FieldName.toLowerCase();
      if (mf.FieldName == '<<Child Name>>') {
        mf.Value = mf.Value;
      }
      if (mf.FieldName) {
        // const val = mf.Value ? mf.Value.toLowerCase() : ' ';
        const val = mf.Value ? mf.Value : ' ';
        const escapedFieldname = mf.FieldName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        let regEx = new RegExp(escapedFieldname, 'gi');
        text = text.replace(regEx.source.toLowerCase(), val);
        text = text.replace(regEx, val);
        // rich text fields have sanitized the merge tag so we need to look for this as well
        let htmlSafeTag = mf.FieldName;
        regEx = new RegExp('<', 'g');
        htmlSafeTag = htmlSafeTag.replace(regEx, '&lt;');
        regEx = new RegExp('>', 'g');
        htmlSafeTag = htmlSafeTag.replace(regEx, '&gt;');
        htmlSafeTag = htmlSafeTag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        regEx = new RegExp(htmlSafeTag, 'gi');
        text = text.replace(regEx.source.toLowerCase(), val);
        text = text.replace(regEx, val);
      }
    });
    return text;
  }

  transformFormOnlyMergeTag(text: string): string {
    let otherMatches: string[] = [];
    const otherFieldsRegEx = new RegExp('<<(.*?)>>', 'g');
    const otherFieldsSanitizedRegEx = new RegExp('&lt;&lt;(.*?)&gt;&gt;', 'g');
    otherMatches = text.match(otherFieldsRegEx);
    if (!otherMatches) {
      otherMatches = text.match(otherFieldsSanitizedRegEx);
    }

    if (otherMatches) {
      otherMatches.forEach(mergeTag => {
        const controlId = this.getControlIdFromMergeTag(mergeTag);
        if (!isNaN(controlId)) {
          const control = this.allFormControls.find(o => o.Id == controlId);
          if (control) {
            let sanitizedValue = '';
            if (control.Value != null) {
              sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, control.Value);
            }
            mergeTag = mergeTag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regEx = new RegExp(mergeTag, 'gi');
            text = text.replace(regEx, sanitizedValue);
          }
        }
      });
    }

    return text;
  }

  // saveStudentPortfolio(document: Portfolio): Observable<any> {
  //   return this.http.post(System.apiURL.Student + `SaveStudentPortfolio`, document, {observe: 'response'});
  // }

  // saveStudentDigitalContent(sdc: StudentDigitalContent, schoolId: number): Observable<number> {
  //   let paramString: string = '';
  //   paramString += '?schoolId=' + schoolId;

  //   return this.http.post<number>(System.apiURL.Student + 'SaveStudentDigitalContent' + paramString, sdc);
  // }

  getTemplateChangeHistory(templateId: number): Observable<EFormChangeHistory[]> {
    const queryString = '?templateId=' + templateId;
    return this.http.get<EFormChangeHistory[]>(System.apiURL.Student + 'GetTemplateChangeHistory' + queryString);
  }

  getTemplateSettingsHistory(templateId: number): Observable<EFormChangeHistory[]> {
    const queryString = '?templateId=' + templateId;
    return this.http.get<EFormChangeHistory[]>(System.apiURL.Student + 'GetTemplateSettingsHistory' + queryString);
  }

  getInstanceChangeHistory(instanceId: number): Observable<EFormChangeHistory[]> {
    const queryString = '?instanceId=' + instanceId;
    return this.http.get<EFormChangeHistory[]>(System.apiURL.Student + 'GetInstanceChangeHistory' + queryString);
  }

  getInstanceSettingsHistory(instanceId: number): Observable<EFormChangeHistory[]> {
    const queryString = '?instanceId=' + instanceId;
    return this.http.get<EFormChangeHistory[]>(System.apiURL.Student + 'GetInstanceSettingsHistory' + queryString);
  }

  saveTemplateChangeHistory(changes: EFormChangeHistory[]): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Student + 'SaveTemplateChangeHistory', changes);
  }

  saveTemplateSettingsHistory(changes: EFormChangeHistory[]): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Student + 'SaveTemplateSettingsHistory', changes);
  }

  saveInstanceChangeHistory(changes: EFormChangeHistory[]): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Student + 'SaveInstanceChangeHistory', changes);
  }

  saveInstanceSettingsHistory(changes: EFormChangeHistory[]): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Student + 'SaveInstanceSettingsHistory', changes);
  }

  getInstancesByTemplateId(templateId: number): Observable<EFormInstance[]> {
    const queryString = '?templateId=' + templateId;
    return this.http.get<EFormInstance[]>(System.apiURL.Student + 'GetInstancesByTemplateId' + queryString);
  }

  getEformTemplateByAuditId(templateAuditId: number): Observable<EFormTemplate> {
    const queryString = '?templateAuditId=' + templateAuditId;
    return this.http.get<EFormTemplate>(System.apiURL.Student + 'GetEformTemplateByAuditId' + queryString);
  }

  getEformInstanceByAuditId(instanceAuditId: number): Observable<EFormInstance> {
    const queryString = '?instanceAuditId=' + instanceAuditId;
    return this.http.get<EFormInstance>(System.apiURL.Student + 'GetEformInstanceByAuditId' + queryString);
  }

  markInstanceAsViewed(instanceId: number): Observable<EFormInstance> {
    const queryString = '?instanceId=' + instanceId;
    return this.http.get<EFormInstance>(System.apiURL.Student + 'MarkInstanceAsViewed' + queryString);
  }

  getSubmissionCounts(yearId: number): Observable<EformSubmissionCounts> {
    const queryString = '?yearId=' + yearId;
    return this.http.get<EformSubmissionCounts>(System.apiURL.Student + 'GetSubmissionCounts' + queryString);
  }


  getSchoolsStudentFamilies(schoolIds: number[], yearId: number, userId: number): Observable<SchoolStudentFamiliesInfo[]> {
    const queryString = '?yearId=' + yearId + '&userId=' + userId;
    return this.http.post<SchoolStudentFamiliesInfo[]>(System.apiURL.Student + 'GetSchoolsStudentFamilyWise' + queryString, schoolIds);
  }

  getSelectedStaffForEForm(instance: EFormInstance): Observable<Staff[]> {
    return this.http.post<Staff[]>(System.apiURL.Admin + 'GetSelectedStaffForEForm', instance);
  }

  getClassStudentFamilies(classIds: number[], yearId: number, userId: number): Observable<SchoolStudentFamiliesInfo[]> {
    const queryString = '?yearId=' + yearId + '&userId=' + userId;
    return this.http.post<SchoolStudentFamiliesInfo[]>(System.apiURL.Student + 'GetClassStudentFamilyWise' + queryString, classIds);
  }

  getStudentFamilies(studentIds: number[], yearId: number, userId: number): Observable<SchoolStudentFamiliesInfo[]> {
    const queryString = '?yearId=' + yearId + '&userId=' + userId;
    return this.http.post<SchoolStudentFamiliesInfo[]>(System.apiURL.Student + 'GetStudentFamilyWise' + queryString, studentIds);
  }

  getStudentFamiliesByService(serviceId: number, yearId: number, instance: EFormInstance): Observable<number[]> {
    const queryString = '?serviceId=' + serviceId + '&yearId=' + yearId;
    return this.http.post<number[]>(System.apiURL.Student + 'GetStudentFamiliesByService' + queryString, instance);
  }

  getSelectedStudentPopupData(instance: EFormInstance, yearId: number, UserId: number, idType: string): Observable<EFormSelectedStudentInfo[]> {
    const queryString = '?yearId=' + yearId + '&userId=' + UserId + '&idType=' + idType;
    return this.http.post<EFormSelectedStudentInfo[]>(System.apiURL.Student + 'GetSelectedStudentPopupData' + queryString, instance);
  }

  getMassMailByParentId(yearId: number, parentId: number[]): Observable<EForm> {
    // const queryString = '?yearId='+yearId+ '&parentId='+parentId;
    const queryString = '?yearId=' + yearId;
    return this.http.post<EForm>(System.apiURL.Student + 'GetMassMailByParentId' + queryString, parentId);
  }

  getDQStudentCount(instance: EFormInstance): Observable<EFormInstance> {
    return this.http.post<EFormInstance>(System.apiURL.Student + 'GetDQStudentCount', instance);
  }

  getStudentIdsFromDynamicQuery(instance: EFormInstance): Observable<number[]> {
    return this.http.post<number[]>(System.apiURL.Admin + 'GetStudentIdsFromDynamicQuery', instance);
  }

  getSurveyQuestionsByTemplateID(templateId: number): Observable<EFormSurveyField[]> {
    const queryString = '?templateId=' + templateId;
    return this.http.get<EFormSurveyField[]>(System.apiURL.Admin + 'GetSurveyQuestionsByTemplateID' + queryString);
  }

  getSurveyQuestionsByInstanceID(instanceId: number): Observable<EFormSurveyField[]> {
    const queryString = '?instanceId=' + instanceId;
    return this.http.get<EFormSurveyField[]>(System.apiURL.Admin + 'GetSurveyQuestionsByInstanceID' + queryString);
  }

  saveEFormSurveyFields(fields: EFormSurveyField[]): Observable<EFormSurveyField[]> {
    return this.http.post<EFormSurveyField[]>(System.apiURL.Admin + 'SaveEFormSurveyFields', fields);
  }

  saveEFormSurveyAnswers(answers: EFormSurveyAnswer[]): Observable<void> {
    return this.http.post<void>(System.apiURL.Admin + 'SaveEFormSurveyAnswers', answers);
  }

  updateInstanceFormDataOnly(instance: EFormInstance): Observable<boolean> {
    return this.http.post<boolean>(System.apiURL.Admin + 'UpdateInstanceFormDataOnly', instance);
  }

  exportEFormsToExcel(eForms: EForm[], eFormInstances: EFormInstance[], notSubmittedHeader: string = '') {
    // PRE: a list of e-forms and (optional but recommended) names associated with instance IDs (for naming the sheets)
    // POST: exports each of those instances to an excel sheet

    // Organizing e-form data
    const instanceIds = [];
    const nameDictionary: { [instanceId: number]: string } = {};
    const eFormDictionary: { [instanceId: number]: EForm[] } = {};
    const instanceControlDictionary: { [instanceId: number]: EFormControl[] } = {};
    const eFormControlDictionary: { [eFormId: number]: EFormControl[] } = {};
    const manualSubmissionDictionary: { [eFormId: number]: boolean } = {};
    eFormInstances.forEach(eFormInstance => {

      // Capturing instance IDs and the names
      if (!nameDictionary[eFormInstance.ID]) {
        nameDictionary[eFormInstance.ID] = eFormInstance.Name;
        instanceIds.push(eFormInstance.ID);
      }

      // Capturing the control dictionary for headers
      instanceControlDictionary[eFormInstance.ID] = this.getAllFormControls(JSON.parse(eFormInstance.FormData) as EFormDataObject).filter(o => {
        return o.ControlType != 'text'
          && o.ControlType != 'image'
          && o.ControlType != 'linkToFile'
          && o.ControlType != 'divider';
      });
    });
    eForms.forEach(eForm => {

      // Categorizing each e-form into their respective e-form instances
      if (!eFormDictionary[eForm.Instance_ID]) {
        eFormDictionary[eForm.Instance_ID] = [];
      }
      eFormDictionary[eForm.Instance_ID].push(eForm);

      // Obtaining each e-forms controls
      if (eForm.FormData) {
        eFormControlDictionary[eForm.ID] = this.getAllFormControls(JSON.parse(eForm.FormData) as EFormDataObject).filter(o => {
          return o.ControlType != 'text'
            && o.ControlType != 'image'
            && o.ControlType != 'linkToFile'
            && o.ControlType != 'divider';
        });
      } else {
        eFormControlDictionary[eForm.ID] = [];
      }

      // Setting whether it was manually submitted
      manualSubmissionDictionary[eForm.ID] = eForm.ManualSubmission;
    });

    // Constructing array of arrays for each instance and each distinct name
    // These will become the excel sheets
    const dataDictionary: { [instanceId: number]: string[][] } = {};
    instanceIds.forEach(instanceId => {
      dataDictionary[instanceId] = [];
      let instanceEForms = eFormDictionary[instanceId];
      // *****Get Current date*****
      const today = new Date();
      const date = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = today.getFullYear();

      const currentDate = mm + '/' + date + '/' + yyyy;

      // **************************
      // Constructing the header
      const instanceControls = instanceControlDictionary[instanceId];
      // --- ONE-9993
      let headerRow: string[] = ['Parent', 'Student Name', 'School', 'Student #', 'Status', 'Submitted By', 'Submitted', 'Note', 'Cell Number', 'Home Number', 'Address', 'Email Address'];  // Header row always has parent and student
      // ONE-9407
      if (eFormInstances[0].TemplateType.toLowerCase() != 'staff' && notSubmittedHeader == 'ExportFromNotSubmittedPopup') {
        headerRow = [eFormInstances[0].Name, currentDate];
        dataDictionary[instanceId].push(headerRow);
        headerRow = ['Parent', 'Student Name', 'School', 'Student #', 'Status', 'Cell Number', 'Home Number', 'Address', 'Email Address'];  // Header row always has parent and student
      }
      if (eFormInstances[0].TemplateType.toLowerCase() == 'staff') {
        // headerRow = [eFormInstances[0].Name, Date()];
        headerRow = [eFormInstances[0].Name, currentDate];
        dataDictionary[instanceId].push(headerRow);
        if (notSubmittedHeader == 'ExportFromNotSubmittedPopup') {
          headerRow = ['Staff', 'Status', 'Cell Number', 'Home Number', 'Address', 'Email Address'];
        }
        else {
          headerRow = ['Staff', 'Status', 'Submitted By', 'Submitted', 'Note', 'Cell Number', 'Home Number', 'Address', 'Email Address'];
        }
      }

      instanceControls.forEach(control => {
        if (notSubmittedHeader == '') {
          headerRow.push(control.Label);
        }
      });
      dataDictionary[instanceId].push(headerRow);

      // Constructing data rows from E-Forms
      if (instanceEForms) {
        // instanceEForms = _.sortBy(instanceEForms, o => o.SubmittedDate);
        // Set order by for same as UI and XML start
        instanceEForms = _.sortBy(instanceEForms, ['SubmittedDate']).reverse();
        const instanceEFormsObj: EForm[] = [];
        instanceEForms.forEach(eForm => {
          if (eForm.SubmittedDate) {
            instanceEFormsObj.push(eForm);
          }
        });
        instanceEForms = _.sortBy(instanceEForms, ['SubmittedDate']).reverse();
        instanceEForms.forEach(eForm => {
          if (!eForm.SubmittedDate) {
            instanceEFormsObj.push(eForm);
          }
        });
        // Set order by for same as UI and XML code end
        instanceEFormsObj.forEach(eForm => {

          // Creating the row for this eForm
          const controls: EFormControl[] = eFormControlDictionary[eForm.ID];
          let eFormStudentName = '';
          if (eForm.StudentNames) {
            eForm.StudentNames.forEach(studentName => {
              if (eFormStudentName.length > 0) {
                eFormStudentName += ', ';
              }
              eFormStudentName += studentName;
            });
          }
          // get Student # Start
          let eFormStrStudentId = '';
          if (eForm.strStudentId) {
            eForm.strStudentId.forEach(strStudentId => {
              if (eFormStrStudentId.length > 0) {
                eFormStrStudentId += ', ';
              }
              eFormStrStudentId += strStudentId;
            });
          }
          // Student # End
          // const dataRow: string[] = [!eForm.ManualSubmission ? (eForm.ParentName) : '', eFormStudentName, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : ''];
          // const dataRow: string[] = [eForm.ParentName, eFormStudentName, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : ''];
          // --- ONE-9993
          let dataRow: string[] = [];
          const student_Name = eFormStudentName.substring(0, eFormStudentName.indexOf(' - '));
          let school_Name = '';
          if (!this.V10) {
            school_Name = eFormStudentName.substring(eFormStudentName.indexOf(' - ') + 3, eFormStudentName.indexOf('#'));
          }
          else {
            school_Name = eFormStudentName.substring(eFormStudentName.indexOf(' - ') + 3, eFormStudentName.length);
          }
          dataRow = [eForm.ParentName, student_Name, school_Name, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : '', eForm.StaffNote, eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
          // ONE-9407
          if (eFormInstances[0].TemplateType.toLowerCase() != 'staff' && notSubmittedHeader == 'ExportFromNotSubmittedPopup') {
            dataRow = [eForm.ParentName, student_Name, school_Name, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
          }
          if (eFormInstances[0].TemplateType.toLowerCase() == 'staff') {
            if (notSubmittedHeader == 'ExportFromNotSubmittedPopup') {
              dataRow = [eForm.StaffName, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
            }
            else {
              dataRow = [eForm.StaffName, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : '', eForm.StaffNote, eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
            }
          }
          if (notSubmittedHeader == '') {
            for (let i = 0; i < instanceControls.length; i++) {
              if (manualSubmissionDictionary[eForm.ID]) {
                dataRow.push('MANUALLY SUBMITTED');
              } else if (controls.length > i) {
                if (controls[i].ControlType == 'attachment' && (controls[i].AttachmentId || controls[i].Attachment)) {
                  dataRow.push('Y');
                  // } else if (controls[i].Value && (instanceControls[i].ControlType != 'radioButtons' || eForm.Status != 'Not Submitted')) {
                } else if (controls[i].Value && (eForm.Status != 'Not Submitted')) {
                  const div = document.createElement('div');
                  div.innerHTML = controls[i].Value;
                  const text = div.textContent || div.innerText || '';
                  dataRow.push(text);
                } else {
                  dataRow.push('');
                }
              }
            }
          }
          dataDictionary[instanceId].push(dataRow);
        });
      }
    });

    // Creating the spreadsheet
    const workSheetsByName: { [name: string]: WorkSheet } = {};
    const sheetNames: string[] = [];
    instanceIds.forEach(instanceId => {
      let name = nameDictionary[instanceId];
      if (!name) {
        name = 'e-form #' + instanceId;
      }
      else {
        for (let i = 0; i < 40; i++) {
          name = name.replace('/', '_');
          name = name.replace('<', '_');
          name = name.replace('>', '_');
          name = name.replace('*', '_');
          name = name.replace('?', '_');
          name = name.replace('"', '_');
          name = name.replace('|', '_');
          name = name.replace('[', '_');
          name = name.replace(']', '_');
          name = name.replace(':', '_');
          name = name.replace(/\\/g, '_');
          name = name.replace('{', '_');
          name = name.replace('}', '_');
        }
      }

      if (name.length > 31) {
        name = name.substring(0, 31);
      }
      sheetNames.push(name);
      workSheetsByName[name] = XLSX.utils.aoa_to_sheet(dataDictionary[instanceId]);
    });
    const workbook: XLSX.WorkBook = { Sheets: workSheetsByName, SheetNames: sheetNames };
    const excelName = sheetNames.length > 1 ? 'e-forms' : sheetNames[0];
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.exportService.saveAs(excelBuffer, excelName, '.xlsx');
  }

  // export all instace to excel

  exportInstancesToExcel(eForms: EForm[], eFormInstances: any[], inclueInstanceSpecificField: boolean) {
    const instanceIds = [];
    const nameDictionary: { [instanceId: number]: string } = {};
    const eFormDictionary: { [instanceId: number]: EForm[] } = {};
    const instanceControlDictionary: { [instanceId: number]: EFormControl[] } = {};
    const eFormControlDictionary: { [eFormId: number]: EFormControl[] } = {};
    const manualSubmissionDictionary: { [eFormId: number]: boolean } = {};

    eFormInstances.forEach(eFormInstance => {
      // Capturing instance IDs and the names
      if (!nameDictionary[eFormInstance.ID]) {
        if (this.V10) {
          nameDictionary[eFormInstance.ID] = eFormInstance.Name;
        }
        else {
          nameDictionary[eFormInstance.ID] = 'e-Forms';
        }
        instanceIds.push(eFormInstance.ID);
      }

      // Capturing the control dictionary for headers
      // instanceControlDictionary[eFormInstance.ID] = this.getAllFormControls(JSON.parse(eFormInstance.FormData) as EFormDataObject).filter(o => {
      //   return o.ControlType != 'text'
      //     && o.ControlType != 'image'
      //     && o.ControlType != 'linkToFile'
      //     && o.ControlType != 'divider';
      // });


      // Capturing the control dictionary for headers
      instanceControlDictionary[eFormInstance.ID] = this.getAllFormControls(JSON.parse(eFormInstance.FormData) as EFormDataObject).filter(o => {
        return o.ControlType != 'text'
          && o.ControlType != 'image'
          && o.ControlType != 'linkToFile'
          && o.ControlType != 'divider';
        // return o.ControlType != 'image'
        //   && o.ControlType != 'linkToFile'
        //   && o.ControlType != 'divider';
      });
    });

    const dataDictionary: { [instanceId: number]: string[][] } = {};
    let oldInstanceId = 0;
    dataDictionary[0] = [];

    // if(!eForms.length){
    //   dataDictionary[0].push([eFormInstances[0].Name]);
    // const headerRow: string[] = ['Parent', 'Students', 'Student #', 'Status', 'Submitted By', 'Submitted'];  // Header row always has parent and student
    // dataDictionary[0].push(headerRow);
    // }
    // Constructing array of arrays for each instance and each distinct name
    // These will become the excel sheets

    instanceIds.forEach(instanceId => {

      eForms.forEach(eForm => {
        if (eForm.Instance_ID == instanceId) {
          // Categorizing each e-form into their respective e-form instances
          if (!eFormDictionary[eForm.Instance_ID]) {
            eFormDictionary[eForm.Instance_ID] = [];
          }
          eFormDictionary[eForm.Instance_ID].push(eForm);

          // Obtaining each e-forms controls
          if (eForm.FormData) {
            // eFormControlDictionary[eForm.ID] = this.getAllFormControls(JSON.parse(eForm.FormData) as EFormDataObject).filter(o => {
            //   return o.ControlType != 'text'
            //     && o.ControlType != 'image'
            //     && o.ControlType != 'linkToFile'
            //     && o.ControlType != 'divider';
            // });


            eFormControlDictionary[eForm.ID] = this.getAllFormControls(JSON.parse(eForm.FormData) as EFormDataObject).filter(o => {
              return o.ControlType != 'text'
                && o.ControlType != 'image'
                && o.ControlType != 'linkToFile'
                && o.ControlType != 'divider';
              // return o.ControlType != 'image'
              //   && o.ControlType != 'linkToFile'
              //   && o.ControlType != 'divider';
            });
          } else {
            eFormControlDictionary[eForm.ID] = [];
          }

          // Setting whether it was manually submitted
          manualSubmissionDictionary[eForm.ID] = eForm.ManualSubmission;
        }
      });

      let instanceEForms = eFormDictionary[instanceId];

      // Constructing data rows from E-Forms
      if (instanceEForms) {
        // Set order by for same as UI and XML start
        instanceEForms = _.sortBy(instanceEForms, ['SubmittedDate']).reverse();
        const instanceEFormsObj: EForm[] = [];
        instanceEForms.forEach(eForm => {
          if (eForm.SubmittedDate) {
            instanceEFormsObj.push(eForm);
          }
        });
        instanceEForms = _.sortBy(instanceEForms, ['SubmittedDate']).reverse();
        instanceEForms.forEach(eForm => {
          if (!eForm.SubmittedDate) {
            instanceEFormsObj.push(eForm);
          }
        });
        // Set order by for same as UI and XML code end

        // Constructing the header
        const instanceControls = instanceControlDictionary[instanceId];


        instanceEFormsObj.forEach(eForm => {
          const instanceType = eFormInstances.filter(o => o.ID == eForm.Instance_ID)[0].TemplateType;
          if (oldInstanceId == 0 || oldInstanceId != instanceId) {
            if (oldInstanceId == 0) {
              dataDictionary[0].push(this.V10 ? [nameDictionary[instanceId]] : [eForm.InstanceName]);
            }
            else if (oldInstanceId > 0 && oldInstanceId != instanceId) {
              dataDictionary[0].push(['']);
              dataDictionary[0].push(this.V10 ? [nameDictionary[instanceId]] : [eForm.InstanceName]);
            }
            // ---- ONE-9993
            let headerRow: string[] = [];
            if (instanceType == 'family') {
                 headerRow = ['Parent', 'Student Name', 'School', 'Student #', 'Status', 'Submitted By', 'Submitted', 'Note', 'Cell Number', 'Home Number', 'Address', 'Email Address'];  // Header row always has parent and student
            }
            else {
              headerRow = ['Student Name', 'School', 'Student #', 'Status', 'Submitted By', 'Submitted', 'Note', 'Cell Number', 'Home Number', 'Address', 'Email Address'];  // Header row always has parent and student
            }

            if (!this.V10) {
              headerRow.push('Grade Level');
            }

            instanceControls.forEach(control => {
              if (inclueInstanceSpecificField && control.ControlType == 'text' && control.Instructions != '' && control.Instructions) {
                headerRow.push(control.Instructions);
              }
              else if (control.ControlType != 'text') {
                headerRow.push(control.Label);
              }
            });

            dataDictionary[0].push(headerRow);

            oldInstanceId = instanceId;
          }

          // Creating the row for this eForm
          const controls: EFormControl[] = eFormControlDictionary[eForm.ID];
          let eFormStudentName = '';
          if (eForm.StudentNames) {
            eForm.StudentNames.forEach(studentName => {
              if (eFormStudentName.length > 0) {
                eFormStudentName += ', ';
              }
              eFormStudentName += studentName;
            });
          }
          // get Student # Start
          let eFormStrStudentId = '';
          if (eForm.strStudentId) {
            eForm.strStudentId.forEach(strStudentId => {
              if (eFormStrStudentId.length > 0) {
                eFormStrStudentId += ', ';
              }
              eFormStrStudentId += strStudentId;
            });
          }
          // Student # End
          // const dataRow: string[] = [!eForm.ManualSubmission ? (eForm.ParentName) : '', eFormStudentName, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : ''];
          // const instanceType = eFormInstances.filter(o => o.ID == eForm.Instance_ID)[0].Type;
          // ---- ONE-9993
          let dataRow: string[] = [];
          const student_Name = eFormStudentName.substring(0, eFormStudentName.indexOf('-') - 1);
          let school_Name = '';
          if (!this.V10) {
            school_Name = eFormStudentName.substring(eFormStudentName.indexOf('-') + 2, eFormStudentName.indexOf('#'));
          }
          else {
            school_Name = eFormStudentName.substring(eFormStudentName.indexOf('-') + 2, eFormStudentName.length);
          }
          if (instanceType && instanceType == 'family') {
            dataRow = [eForm.ParentName, student_Name, school_Name, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : '', eForm.StaffNote, eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
          }
          else {
            dataRow = [student_Name, school_Name, eFormStrStudentId, eForm.Status + (eForm.ManualSubmission ? ' M' : ''), eForm.SubmittedByName, eForm.SubmittedDate ? ((moment(eForm.SubmittedDate).format('MM/DD/YY hh:mm A')).toString()) : '', eForm.StaffNote, eForm.Cell_number, eForm.Home_Number, eForm.Address, eForm.Email_Address];
          }

          if (!this.V10) {
            dataRow.push(eForm.GradeLevel);
          }

          for (let x = 0; x < instanceControls.length; x++) {
            if (instanceControls[x].ControlType != 'text') {
              if (manualSubmissionDictionary[eForm.ID]) {
                dataRow.push('MANUALLY SUBMITTED');
              } else if (controls.length > x) {
                if (controls[x].ControlType == 'attachment' && (controls[x].AttachmentId || controls[x].Attachment)) {
                  dataRow.push('Y');
                  // } else if (controls[i].Value && (instanceControls[i].ControlType != 'radioButtons' || eForm.Status != 'Not Submitted')) {
                } else if (controls[x].Value && (eForm.Status != 'Not Submitted')) {
                  const div = document.createElement('div');
                  div.innerHTML = controls[x].Value;
                  const text = div.textContent || div.innerText || '';
                  dataRow.push(text);
                } else {
                  dataRow.push('');
                }
              }
            }
            else if (inclueInstanceSpecificField && instanceControls[x].ControlType == 'text' && instanceControls[x].Instructions != '' && instanceControls[x].Instructions) {
              if (eForm.Status != 'Not Submitted') {
                const div = document.createElement('div');
                div.innerHTML = instanceControls[x].Value;
                const text = div.textContent || div.innerText || '';
                dataRow.push(text);
                // dataRow.push(instanceControls[i].Value);
              }
              else {
                dataRow.push('');
              }
            }
          }
          dataDictionary[0].push(dataRow);
        });
      }
    });

    // Creating the spreadsheet
    const workSheetsByName: { [name: string]: WorkSheet } = {};
    const sheetNames: string[] = [];
    const worksheet: WorkSheet[] = [];
    let i = 0;
    if (!instanceIds || !instanceIds.length) {
      instanceIds.push({ ID: 0 });
    }

    instanceIds.forEach(instanceId => {
      i++;
      let name = this.V10 ? 'e-Forms' : nameDictionary[instanceId];

      if (!name) {
        name = 'e-Forms'; // + instanceId;
      }

      if (name.length > 31) {
        name = name.substring(0, 31);
      }
      if (i == 1) {
        sheetNames.push(name);
      }

      workSheetsByName[name] = (XLSX.utils.aoa_to_sheet(dataDictionary[0]));
    });
    const workbook: XLSX.WorkBook = { Sheets: workSheetsByName, SheetNames: sheetNames };
    const excelName = 'e-Forms';
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.exportService.saveAs(excelBuffer, excelName, '.xlsx');
  }

  addEFormAttachmentsToPDF(usePDFSpecificAttachments: boolean = true) {
    let attachmentDetailPage: jspdf = new jspdf('p', 'mm', 'letter'); // letter size page of PDF;
    const pageCenterX = attachmentDetailPage.internal.pageSize.getWidth() / 2;
    const pageCenterY = attachmentDetailPage.internal.pageSize.getHeight() / 2;
    let attachmentNumber = 1;

    let attachments: EFormAttachment[] = [];

    if (usePDFSpecificAttachments) {
      attachments = this.eFormAttachmentForPDF;
    }
    else {
      this.eFormAttachment.forEach(attachment => {
        if (this.allFormControls.filter(control => control.AttachmentId && control.ControlType == 'attachment' && control.AttachmentId == attachment.ID).length > 0) {
          attachments.push(attachment);
        }
      });
    }

    attachments.forEach(attachment => {
      attachmentDetailPage = new jspdf('p', 'mm', 'letter'); // letter size page of PDF;
      attachmentDetailPage.text(attachment.OriginalFileName, pageCenterX, pageCenterY, 'center');
      this.pdfDataURIs.push(attachmentDetailPage.output('datauristring'));
      attachmentNumber++;

      switch (attachment.FileType) {
        case 'application/pdf':
          this.pdfDataURIs.push(attachment.FileDataBase64);
          break;
        case 'image/jpeg':
        case 'image/png':
          const pdfJS: jspdf = new jspdf('p', 'mm', 'letter'); // letter size page of PDF;
          const yOffset = 10;
          // ***********
          const width = pdfJS.internal.pageSize.getWidth();
          const height = pdfJS.internal.pageSize.getHeight();
          // **********
          // pdfJS.addImage(attachment.FileDataBase64, 'JPEG', 10, yOffset,100,100);
          pdfJS.addImage(attachment.FileDataBase64, 'JPEG', 10, yOffset, width - 10, height);
          this.pdfDataURIs.push(pdfJS.output('datauristring'));
          break;
        default:
          break;
      }
    });

    this.eFormAttachmentForPDF = [];
  }

  async getPdfDataUriAsBase64() {
    const multiPdfDoc = await PDFDocument.create();

    for (let i = 0; i < this.pdfDataURIs.length; i++) {
      const pdfDoc = await PDFDocument.load(this.pdfDataURIs[i]);

      for (let j = 0; j < pdfDoc.getPageCount(); j++) {
        const copiedPage = await multiPdfDoc.copyPages(pdfDoc, [j]);
        const [page] = copiedPage;
        multiPdfDoc.addPage(page);
      }
    }

    const pdfBase64 = await multiPdfDoc.saveAsBase64();

    return pdfBase64;
  }

  getSurveySummary(instanceId: number, yearId: number, schoolId: number, criticalOnly: boolean, includeResultsForAllSchools: boolean, getMostRecent: boolean, startDate: string): Observable<EFormsSurveySummary[]> {
    const queryString = '?instanceId=' + instanceId +
      '&yearId=' + yearId +
      '&schoolId=' + schoolId +
      '&criticalOnly=' + criticalOnly +
      '&includeResultsForAllSchools=' + includeResultsForAllSchools +
      '&getMostRecent=' + getMostRecent +
      '&startDate=' + startDate;
    return this.http.get<EFormsSurveySummary[]>(System.apiURL.Admin + 'GetSurveySummary' + queryString);
  }

  getSurveyNotSubmitted(instanceId: number, yearId: number, schoolId: number, includeResultsForAllSchools: boolean, getMostRecent: boolean, startDate: string): Observable<EFormsSurveySummary[]> {
    const queryString = '?instanceId=' + instanceId +
      '&yearId=' + yearId +
      '&schoolId=' + schoolId +
      '&includeResultsForAllSchools=' + includeResultsForAllSchools +
      '&getMostRecent=' + getMostRecent +
      '&startDate=' + startDate;
    return this.http.get<EFormsSurveySummary[]>(System.apiURL.Admin + 'GetSurveyNotSubmitted' + queryString);
  }

  getSurveyAnswerDetails(instanceId: number, yearId: number, schoolId: number): Observable<EFormsSurveySummary[]> {
    const queryString = '?instanceId=' + instanceId +
      '&yearId=' + yearId +
      '&schoolId=' + schoolId;
    return this.http.get<EFormsSurveySummary[]>(System.apiURL.Admin + 'GetSurveyAnswerDetails' + queryString);
  }

  getEFormSurveyAnswerSummary(instanceId: number, yearId: number, schoolId: number, startDate: string, getMostRecent: boolean, includeAllSchools: boolean): Observable<EFormsSurveyAnswerSummary[]> {
    const queryString = '?instanceId=' + instanceId +
      '&yearId=' + yearId +
      '&schoolId=' + schoolId +
      '&startDate=' + startDate +
      '&getMostRecent=' + getMostRecent +
      '&includeAllSchools=' + includeAllSchools;
    return this.http.get<EFormsSurveyAnswerSummary[]>(System.apiURL.Admin + 'GetEFormSurveyAnswerSummary' + queryString);
  }
}
